import {Component, Input} from '@angular/core';
import {ThemePalette} from '@angular/material/core';

export type LoaderSize = 16 | 32 | 64 | 96 | 128;

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  @Input() public loading: boolean;
  @Input() public size: LoaderSize = 96;
  @Input() public color: ThemePalette;
  @Input() public overlay: boolean;
  @Input() public cardOverlay: boolean;
  @Input() public filterOverlay: boolean;
}
